module.exports = __webpack_public_path__ + "static/media/Humana uses Curoflow telemedicine software for digital patient care.b108123f.webp";